var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSeparator = function SvgSeparator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10 12h12v8H10zM22 11H10c0-1.657 2.686-3 6-3s6 1.343 6 3M10 21h12c0 1.657-2.686 3-6 3s-6-1.343-6-3"
  })));
};
export { SvgSeparator as ReactComponent };
export default "data:image/svg+xml,%3csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath d='M10 12H22V20H10V12Z' fill='%234A6067'/%3e %3cpath d='M22 11H16H10C10 9.34315 12.6863 8 16 8C19.3137 8 22 9.34315 22 11Z' fill='%234A6067'/%3e %3cpath d='M10 21L16 21L22 21C22 22.6569 19.3137 24 16 24C12.6863 24 10 22.6569 10 21Z' fill='%234A6067'/%3e %3c/svg%3e";